import { render, staticRenderFns } from "./AbbreviationTimeDetail.vue?vue&type=template&id=1535ff3b&"
import script from "./AbbreviationTimeDetail.vue?vue&type=script&lang=js&"
export * from "./AbbreviationTimeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports